
import {Vasat,VasatConfig, VasatModel, SearchQueryNode,AsClass, User,VasatModelClass} from 'vasat';
import {Observable} from 'rxjs';
import { AppConstants } from './global';


abstract class AppBaseModel<T extends VasatModel<T>> extends VasatModel<T>{

    json:any

    toJSON() {
        var res = super.toJSON()
        delete res["permissions"]
        delete res["type"]
        return res
    }

}
  

export abstract class ACLModel<T extends VasatModel<T>> extends VasatModel<T>{
  
  canWrite:boolean
  canRead:boolean
  canDelete:boolean
  permissions:string[]
  
  set(a:any){
    super.set(a)
    if(this.permissions){
      this.canRead = !!this.permissions.find(p => p == 'api_read')
      this.canWrite = !!this.permissions.find(p => p == 'api_update')
      this.canDelete = !!this.permissions.find(p => p == 'api_delete')
    }
    return this
  }
  toJSON():any{
    let o = super.toJSON()
    let res = {}
    Object.keys(o).filter(k => k != 'canRead' && k != 'canWrite').forEach(k => res[k] = o[k])

    delete o.permissions
    delete o.canDelete
    delete o.canRead
    delete o.canWrite

    return res
  }
 
}


export class ObjectMeta extends ACLModel<ObjectMeta>{
  uid:string
  qMap:any[]
  level:string
  strip:any
  seq?:number
  account_acl:{[sqn:string] : string[]} = {}
  acl:string[] = []
  
  columns:string[]
  
  isSite:boolean

  cascades:{
    field:string,
     type:string,
     derived?:any
  }[]

  filters:{
    name:string,
    query:SearchQueryNode,
    showSubs:boolean,
    columns?:string[]
  }[]

  derived:any
  baseFilter:SearchQueryNode  

  stubClazz:VasatModelClass<any>
  
  constructor(V:Vasat,r?:any){
    super(V,'ObjectMeta',r)

  }

  set(a:any){
    super.set(a)
    var self = this

    var reg:VasatModelClass<any> = this.vasat.registeredClassForString(self.uid)
    
    if(!reg){
        var self = this
        reg = class StubImpl extends VasatModel<StubImpl>{
                  constructor(){
                    super(self.vasat,self.uid)
                  }
                  className(){
                      return self.uid
                  }
            }
        this.vasat.registerClass(reg)     
    }

    this.stubClazz = reg
    return this
  }
  toJSON():any{
      let o = super.toJSON()
      delete o.account_acl
      delete o.acl_createSqns
      delete o.acl_searchSqns
      delete o.acl
      delete o.selected
      delete o.canDelete
      delete o.permissions

      delete o.type
      return o
  }



}

export interface TicketRequest {
  subject?:string,
  priority:'urgent'|'high'|'normal'|'low',
  category:'problem'|'incident'|'question'|'task',
  body?:string
}

export interface WMSUrlExtent {
  minX:number,
  minY:number,
  maxX:number,
  maxY:number,
  crs:number
}

export interface WMSUrlLayer {
  id?:string,
  label?:string
  description?:string
  bounds?:WMSUrlExtent,
  meta?:any
  legendURL?:string
  previewURL?:string,
  subLayers?:WMSUrlLayer[]
}
export interface WMSUrlMeta {
  id:string,
  label?:string
  description?:string
  type:string
  urlMethod:string,
  baseURL:string
  meta?:any
  layers:WMSUrlLayer[]
}

export interface WMSUrlRequest {
  url:String
  username?:string
  password?:string
  authMethod?:string
}

export interface WMSCreateRequest {
  meta:WMSUrlMeta,
  layerIds:string[],
  username?:string
  password?:string
  authMethod?:string 
}